// Test IDs for the wedding RSVP site
export const RSVP = {
  nameInput: 'rsvp-name-input',
  phoneInput: 'rsvp-phone-input',
  attendingYes: 'rsvp-attending-yes',
  attendingNo: 'rsvp-attending-no',
  plusOneYes: 'rsvp-plus-one-yes',
  plusOneNo: 'rsvp-plus-one-no',
  submitButton: 'rsvp-submit-button',
  scrollToRsvp: 'scroll-to-rsvp-button',
  successCard: 'rsvp-success-card',
  resetButton: 'rsvp-reset-button',
};

export const NAV = {
  navHome: 'nav-home-link',
  navRsvp: 'nav-rsvp-link',
  navAdmin: 'nav-admin-link',
};

export const ADMIN = {
  passwordInput: 'admin-password-input',
  loginButton: 'admin-login-button',
  logoutButton: 'admin-logout-button',
  statTotal: 'admin-stat-total',
  statYes: 'admin-stat-yes',
  statNo: 'admin-stat-no',
  statPlusOnes: 'admin-stat-plus-ones',
  statGuests: 'admin-stat-guests',
  rsvpsTable: 'admin-rsvps-table',
  emptyState: 'admin-empty-state',
  deleteRow: 'admin-delete-row',
};
